import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';

export default class JobHeaderSlider {
  constructor() {
    this.sliderSelector = '[data-job-header-slider]';
    this.init();
  }

  init() {
    const sliders = document.querySelectorAll(this.sliderSelector);

    if (sliders.length === 0) {
      return;
    }

    sliders.forEach(sliderElement => {
      this.initSlider(sliderElement);
    });
  }

  initSlider(element) {
    const splide = new Splide(element, {
      type: 'loop',
      autoplay: true,
      interval: 10000,
      speed: 900,
      pauseOnHover: true,
      pauseOnFocus: true,
      arrows: true,
      pagination: false,
      lazyLoad: 'nearby',
      breakpoints: {
        768: {
          arrows: false,
        }
      }
    });

    splide.mount();
  }
}

if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new JobHeaderSlider();
    });
  } else {
    new JobHeaderSlider();
  }
}
